
import $ from 'jquery'
// http://kenwheeler.github.io/slick/
import 'slick-carousel'

export default function () {
  var $slider = $('.site-header__slider')

  // Prevent slider to start if it doesn't exist
  if (!$slider.length) {
    return
  }

  // Slider options
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    infinite: true,
    fade: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./scripts/lib/slider.js